import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = { class: "job-details-pages pt-120 mb-120" }
const _hoisted_7 = {
  key: 0,
  class: "container"
}
const _hoisted_8 = { class: "row g-lg-4 gy-5" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "job-details-content" }
const _hoisted_11 = { class: "job-list-content" }
const _hoisted_12 = { class: "company-area" }
const _hoisted_13 = { class: "logo" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "company-details" }
const _hoisted_16 = { class: "name-location" }
const _hoisted_17 = { href: "#" }
const _hoisted_18 = { class: "job-discription" }
const _hoisted_19 = { class: "one" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/map-2.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Location:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Qualification:", -1)
const _hoisted_24 = {
  class: "card",
  style: {"height":"45em !important"}
}
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Job Seeker About:")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "row p-4"
}
const _hoisted_28 = {
  key: 1,
  class: "row p-4"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h5", null, "No Description Found!...", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "col-lg-4" }
const _hoisted_32 = {
  key: 0,
  class: "job-details-sidebar mb-120"
}
const _hoisted_33 = {
  class: "job-summary-area mb-50",
  style: {"height":"558px !important"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "job-summary-title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Job Seeker Summary:")
], -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Name:", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Email:", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Phone:", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Gender:", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Designation:", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Address:", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "location-area" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Get Location:"),
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3649.564763018799!2d90.36349791490355!3d23.834071191491947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c14c8682a473%3A0xa6c74743d52adb88!2sEgens%20Lab!5e0!3m2!1sen!2sbd!4v1674212581590!5m2!1sen!2sbd",
    style: {"border":"0"},
    allowfullscreen: "",
    loading: "lazy",
    referrerpolicy: "no-referrer-when-downgrade"
  })
], -1)
const _hoisted_43 = { class: "row" }
const _hoisted_44 = {
  key: 0,
  class: "col-lg-12",
  id: "user-applied-on-job-form"
}
const _hoisted_45 = {
  class: "related-jobs",
  id: "scrollTarget"
}
const _hoisted_46 = { class: "section-title mb-40" }
const _hoisted_47 = { class: "row g-lg-4 gy-5" }
const _hoisted_48 = { class: "col-lg-8" }
const _hoisted_49 = { class: "my-profile-inner" }
const _hoisted_50 = { class: "form-wrapper mb-60" }
const _hoisted_51 = { class: "profile-form" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-inner mb-25" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", null, "Upload your resume*", -1)
const _hoisted_56 = { class: "input-area" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-inner mb-25" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, "Your Current Designation", -1)
const _hoisted_61 = { class: "input-area" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "form-inner mb-25" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", null, "Your Exprience", -1)
const _hoisted_66 = { class: "input-area" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-inner mb-25" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", null, "Expected Salary", -1)
const _hoisted_71 = { class: "input-area" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_73 = { class: "col-md-12" }
const _hoisted_74 = { class: "form-inner" }
const _hoisted_75 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "row mt-5" }
const _hoisted_82 = { class: "col-lg-12" }
const _hoisted_83 = { class: "section-title" }
const _hoisted_84 = { class: "be-comment-block" }
const _hoisted_85 = { class: "be-comment" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "be-img-comment" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "blog-detail-2.html" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://bootdey.com/img/Content/avatar/avatar1.png",
      alt: "",
      class: "be-ava-comment"
    })
  ])
], -1)
const _hoisted_87 = { class: "be-comment-content" }
const _hoisted_88 = { class: "be-comment-name" }
const _hoisted_89 = { href: "blog-detail-2.html" }
const _hoisted_90 = { class: "be-comment-time" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o" }, null, -1)
const _hoisted_92 = { class: "be-comment-text" }
const _hoisted_93 = { class: "form-block" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-xs-12" }
const _hoisted_96 = { class: "form-group mb-3" }
const _hoisted_97 = { class: "form-group mb-3" }
const _hoisted_98 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Jobseeker Details", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.jobSeekerData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.jobSeekerData.photo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              width: "200",
                              src: _ctx.jobSeekerData.photo
                            }, null, 8, _hoisted_14))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h5", null, [
                            _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.jobSeekerData.name), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("ul", _hoisted_19, [
                        _createElementVNode("li", null, [
                          _hoisted_20,
                          _createElementVNode("p", null, [
                            _hoisted_21,
                            _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData.location?.name), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _hoisted_22,
                          _createElementVNode("p", null, [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData.qualification?.name), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    (_ctx.jobSeekerData.description !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.jobSeekerData.description), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_ctx.jobSeekerData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        (_ctx.jobSeekerData)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_36,
                                  _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData?.name), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_37,
                                  _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData?.email), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_38,
                                  _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData?.phone), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_39,
                                  _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData?.gender), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_40,
                                  _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData?.designtion?.name), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_41,
                                  _createTextVNode(" " + _toDisplayString(_ctx.jobSeekerData?.address), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_42
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              (_ctx.role == 'Job Seeker' && !_ctx.user_job_seeker_detail_applied)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("h3", null, "Apply For " + _toDisplayString(_ctx.job_seeker_detail.job_title), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("form", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createElementVNode("div", _hoisted_56, [
                                      _hoisted_57,
                                      _createElementVNode("input", {
                                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                                        type: "file",
                                        name: "cv"
                                      }, null, 32)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _hoisted_60,
                                    _createElementVNode("div", _hoisted_61, [
                                      _hoisted_62,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.application.designation) = $event)),
                                        placeholder: "What is your current designation"
                                      }, null, 512), [
                                        [_vModelText, _ctx.application.designation]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _hoisted_65,
                                    _createElementVNode("div", _hoisted_66, [
                                      _hoisted_67,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.application.experience) = $event)),
                                        placeholder: "How many years of experince do you have ?"
                                      }, null, 512), [
                                        [_vModelText, _ctx.application.experience]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", _hoisted_69, [
                                    _hoisted_70,
                                    _createElementVNode("div", _hoisted_71, [
                                      _hoisted_72,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.application.salary) = $event)),
                                        placeholder: "What is your expected salary ?"
                                      }, null, 512), [
                                        [_vModelText, _ctx.application.salary]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("div", _hoisted_74, [
                                    (!_ctx.isLoading)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyForPosition && _ctx.applyForPosition(...args))),
                                          class: "primry-btn-2 lg-btn w-unset",
                                          type: "button"
                                        }, "Submit Application"))
                                      : (_openBlock(), _createElementBlock("button", _hoisted_75, _hoisted_78))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_79
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("h4", null, "Reviews (" + _toDisplayString(_ctx.jobSeekerData.reviews?.length) + "):", 1)
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobSeekerData.reviews, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _hoisted_86,
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("span", _hoisted_88, [
                            _createElementVNode("a", _hoisted_89, _toDisplayString(item.author_name), 1)
                          ]),
                          _createElementVNode("span", _hoisted_90, [
                            _hoisted_91,
                            _createTextVNode(" May 27, 2015 at 3:14am " + _toDisplayString(item.reviewed_on), 1)
                          ]),
                          _createElementVNode("p", _hoisted_92, _toDisplayString(item.review), 1)
                        ])
                      ]))
                    }), 256)),
                    _createElementVNode("form", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", _hoisted_96, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-input",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reviewForm.review) = $event)),
                              placeholder: "Your Review"
                            }, null, 512), [
                              [_vModelText, _ctx.reviewForm.review]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-input",
                              max: "5",
                              min: "0",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reviewForm.rating) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.reviewForm.rating]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.createReview && _ctx.createReview(...args))),
                            class: "primry-btn-2 lg-btn w-unset",
                            type: "button"
                          }, "Submit Review")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}